import $ from "jquery";
import run from "../../../utilities/run";
require("../../stubs/hcuGuideStub/hcuGuide.less");
require("../../stubs/hcuLeftNav/hcuLeftNav.less");
import {swapClassesViaBool} from "../../../utilities/selectorHelpers";
import _ from 'underscore';

const guidesOuterSelector = "#p_p_id_navigationportlet_WAR_commerceuportlet_ #guidesContents";

run(guidesOuterSelector, ()=>{
	attachGuides();
});

function attachGuides(){
	
	/** Script to expand and make active currnet url link on guides page **/
	
	var currentUrl = window.location.href.split('-/')[1];
	if(currentUrl !== undefined){
		let questionIndex = currentUrl.indexOf("?");
		if(questionIndex > -1){
			currentUrl = currentUrl.substring(0,questionIndex);
		}

		$( "#guidesContents a.active" ).each(function() {
			var activeUrl = $( this ).attr('id');
			if(currentUrl === activeUrl) {
				let parentEL = $(this).parent();
				parentEL.addClass("active");
				parentEL.parent().addClass("in");
				parentEL.closest(".hcu-second-level").addClass("active");				
			}
		});		
	}
	
	
	
	/** click on guide folder on left navigation should expand folder and how the articles in it **/
	
	$('.hcu-nav .q-sidebar-link').click(function(event) {
		event.preventDefault();
		if ($(this).parent().hasClass('active')) {
			$(this).next('.collapse').toggleClass('in');
			$(this).parent().toggleClass('active');
		} else {
			$(".collapse.in").removeClass("in");
			$("li.active").removeClass("active");
			$(this).next('.collapse').toggleClass('in');
			$(this).parent().toggleClass('active');
		}
	});
	
	
	/** load glossary term on guides contents
		Loop through each element, see if there are duplicate glossary term within one body section
		if multiple glossary section is found then remove duplicate and get data only for one unique glossary term **/
	
	$(".termTracker").each(function() {
			var found = {};
			$(this).find(".dupTracker").each(function() {
				var $this = $(this);
				/** must use attribute and iterate through the all elements because we need 
					to track duplicate based on data in attribute "termtitle" which is very dynamic in nature **/
				var termtitle = $this.attr("termtitle");
				if (found[termtitle]) {
					$this.hide();
				} else {
					found[termtitle] = true;
					findGlossaryTerm($this.text(), $( this ));
				}
			});
	});
	const icon = $('.hcu-toggle-icon');
	$(".hcu-guide-menu").click(function(event){
		event.preventDefault();
		toggleNavBarIcons();
	});
	
	$(".hcu-side-nav-icon").click(function(event){
		event.preventDefault();
		//const icon = $(this).parent().find('.hcu-toggle-icon');
		toggleNavBarIcons();
	});

	const hcuList = $(".hcu-list-txt");
	const hcuSidebarLayout = $('.hcu-sidebar-layout');
	const $window = $(window);

	function toggleNavBarIcons(){
		if(isSidebarOpen(icon)){
			hideSidebar();
		}
		else{
			showSidebar();
		}
	}

	function isSidebarOpen(icon){
		return icon.hasClass('fa-chevron-left');
	}
	

	function showSidebar(){
		swapClassesViaBool(icon, "fa-chevron-left", "fa-chevron-right", true);
		hcuList.text("Hide List");
		hcuSidebarLayout.removeClass("hcu-list-toggle");
	}

	function hideSidebar(){
		swapClassesViaBool(icon, "fa-chevron-left", "fa-chevron-right", false);
		hcuList.text("Show List");
		hcuSidebarLayout.addClass("hcu-list-toggle");
	}

	
	//handle side nav breadcrumb
	var isResizedToMobile = false;
	handleSiteBreadcrumbForMobile();


	function handleSiteBreadcrumbForMobile() {
		var width = $window.width();
		if (!isResizedToMobile && width < 768) {
			hideSidebar();
			isResizedToMobile = true;
		}
		else if(isResizedToMobile && width >= 768){
			// we also want to check going FROM mobile TO desktop
			// whether or not it was ORIGINALLY open in mobile
			if(isSidebarOpen(icon)){
				showSidebar();
			}
			else{
				hideSidebar();
			}
			isResizedToMobile = false;
		}
	}
	var lazyResize = _.debounce(handleSiteBreadcrumbForMobile, 100);
	$window.resize(lazyResize);
}

 function findGlossaryTerm(glossaryTitle, el) {
	$.ajax({
			url: $("#displayContent").data("find-glossary-term-url"),
			datatype:'json',
			data: {
				glossaryTitle: glossaryTitle
			},
			success: function(data) {
				el.html('');// to clear the previous option
				el.append(data);
				el.show("fast");
			}
	});
}



// WEBPACK FOOTER //
// ./src/pages/hcu/guides/guides.js